var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c(
        "el-form",
        {
          ref: "projectForm",
          attrs: { model: _vm.form, "label-width": "170px", rules: _vm.rules },
        },
        [
          _c(
            "el-row",
            { staticClass: "marRight20" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "项目名称：", prop: "matchName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.matchName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "matchName", $$v)
                      },
                      expression: "form.matchName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目类型：", prop: "matchType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.form.matchType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "matchType", $$v)
                        },
                        expression: "form.matchType",
                      },
                    },
                    _vm._l(_vm.list, function (i) {
                      return _c("el-option", {
                        key: i.id,
                        attrs: { label: i.matchTypeName, value: i.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目年份：", prop: "matchYear" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.form.matchYear,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "matchYear", $$v)
                        },
                        expression: "form.matchYear",
                      },
                    },
                    _vm._l(_vm.yearList, function (i) {
                      return _c("el-option", {
                        key: i.value,
                        attrs: { label: i.label, value: i.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目级别：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { multiple: "" },
                      model: {
                        value: _vm.form.schoolType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "schoolType", $$v)
                        },
                        expression: "form.schoolType",
                      },
                    },
                    _vm._l(_vm.typeList, function (i) {
                      return _c("el-option", {
                        key: i.valueData,
                        attrs: { label: i.keyData, value: i.valueData },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "项目开始结束时间：" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "选择开始时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "startTime", $$v)
                          },
                          expression: "form.startTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { span: 2 },
                    },
                    [_vm._v("至")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "选择结束时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "endTime", $$v)
                          },
                          expression: "form.endTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              this.proFlag === 1
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "专家承诺书：", "label-width": "170px" },
                    },
                    [
                      _c("FileUpload", {
                        attrs: { title: "承诺书上传" },
                        on: { successData: _vm.getUploadFileData },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submitBtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.submit("projectForm")
                },
              },
            },
            [_vm._v("保存")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.isBack } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }